import { RouteRecordRaw } from "vue-router";

export const enum RouteNames {
  contact = "contact",
  faq = "faq",
  support = "support",
}

export default [] as RouteRecordRaw[];
